module.exports = __webpack_public_path__ + "img/absorbente13.9a33c77e.jpg";